import React from "react";
import { motion } from "framer-motion";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { springVariants, springViewport } from '../utils/framerVariants';

const Galery = ({ data }) => {
  const isPortrait = data.portraitMode === true;
  const galeryEntriesCount = data.GaleryEntries.length;

  let gridClass, imageClass;

  if (isPortrait) {
    imageClass = "aspect-DINA2 md:max-w-sm xl:max-w-md";
  } else {
    imageClass = "aspect-3/2";
  }

  if (galeryEntriesCount <= 2) {
    gridClass = "grid-cols-1 md:grid-cols-2"; // Classes for one or two entries
  } else {
    gridClass = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"; // Classes for more than two entries
  }

  return (
    <article className={`gallery container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl mb-8 md:mb-16 lg:mb-24 xl:mb-40 px-4 md:px-8 xl:px-24`}>
      <div className={`grid ${gridClass} gap-x-8`}>
        {data.GaleryEntries.map((entry, i) => (
          <motion.div
            key={i}
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className="col-span-1"
          >
            <div className="mb-4 md:mb-6">
              {entry.Media && (
                <GatsbyImage
                  className={imageClass}
                  image={getImage(entry.Media.file)}
                  alt={entry.Media.alternativeText || "Alternative Text missing"}
                />
              )}
            </div>
            <div className="mb-16 pr-4 md:pr-8">
              {entry.Subheadline && (
                <p className="mb-1 text-text-sm tracking-text-sm leading-text-sm">{entry.Subheadline}</p>
              )}
              {entry.Headline && (
                <h2 className="text-headline-md tracking-headline-md leading-headline-md font-bold mb-6">{entry.Headline}</h2>
              )}
              {entry.Text && <div className="pr-12 md:pr-0" dangerouslySetInnerHTML={{ __html: entry.Text }} />}
            </div>
          </motion.div>
        ))}
      </div>
    </article>
  );
};

export default Galery;
